import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import './Download.scss';

const SvgDownloadIcon = ({ className, theme = 'brand' }) => {
  const svgClasses = classnames('svg', 'svg-download', className);
  const pathClasses = classnames('svg-download__path', `svg-download__path--theme-${theme}`);
  return (
    <svg
      className={svgClasses}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        className={pathClasses}
        d="M12.0014 2.00068C11.4495 2.00068 11.0021 2.44807 11.0021 2.99996V14.5003L6.13548 9.49819C5.74188 9.09365 5.09169 9.0948 4.69953 9.50073L4.68082 9.52009C4.30547 9.90862 4.30656 10.525 4.68328 10.9122L11.2847 17.6973C11.6773 18.1009 12.3255 18.1009 12.7182 17.6973L19.3172 10.9147C19.6949 10.5265 19.6949 9.9082 19.3172 9.52002L19.3028 9.5052C18.9104 9.1019 18.2626 9.10161 17.8699 9.50455L13.0007 14.5003L13.0007 2.99996C13.0007 2.44807 12.5533 2.00068 12.0014 2.00068Z"
        fill="#1A5EE5"
      />
      <rect className={pathClasses} x="4" y="20" width="16" height="2" rx="1" fill="#1A5EE5" />
    </svg>
  );
};

SvgDownloadIcon.propTypes = {
  className: PropTypes.string,
  theme: PropTypes.oneOf(['brand', 'disabled']),
};

export default SvgDownloadIcon;
